// The backend answers 409 with this code when a Google account's credentials
// are dead (revoked, or expired after 7 days while the OAuth app is in Testing).
// Only a new consent fixes it, so the UI asks for that instead of "try later".
// What the client sees for any metrics error: never provider names, accounts or setup steps.
export const CLIENT_ERROR_MESSAGE = "Ha ocurrido un error al cargar los datos. Inténtalo de nuevo más tarde.";

export const GOOGLE_REAUTH_CODE = "google_reauth_required";

export const isGoogleReauthError = (err) =>
  err?.response?.status === 409 && err?.response?.data?.code === GOOGLE_REAUTH_CODE;

export const googleReauthMessage = (err, action = "vuelve a autorizarla") => {
  const email = err?.response?.data?.email;
  return `La autorización de Google${email ? ` de ${email}` : ""} ha caducado, ${action}.`;
};
